import React, { useEffect, useState } from "react";
import { orderService } from "../../services/orderService";
import { Link } from "react-router-dom";
import styles from "../../styles/Admin.module.css";

interface Order {
  id: string;
  clientName: string;
  status: string;
  price: number;
}

const OrderList: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await orderService.getAll();
        setOrders(res);
      } catch (err) {
        console.error("Failed to fetch orders:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const filteredOrders =
    filter === "all" ? orders : orders.filter((o) => o.status === filter);

  return (
    <div className={`${styles["admin-container"]} ${styles["bg-white"]} ${styles["p-6"]} ${styles["rounded"]}`}>
      <h2 className={styles["admin-header"]}>Orders</h2>

      {/* Filter Bar */}
      <div className={`${styles["flex"]} ${styles["justify-end"]} ${styles["gap-4"]} ${styles["mb-4"]}`}>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className={styles.statusSelect}
        >
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="shipped">Shipped</option>
          <option value="delivered">Delivered</option>
        </select>

        <Link to="/admin/orders/new" className={styles.adminAddButton}>
          + Create Order
        </Link>
      </div>

      {loading ? (
        <p>Loading orders...</p>
      ) : (
        <div className={styles["table-responsive"]}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Customer</th>
                <th>Status</th>
                <th>Order Total (UGX)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order) => (
                <tr key={order.id}>
                  <td>{order.clientName}</td>
                  <td>{order.status}</td>
                  <td>{Number(order.price).toLocaleString()}</td>
                  <td>
                    <Link to={`/admin/orders/edit/${order.id}`} className={styles.adminAddButton}>
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OrderList;
